import React, { FC } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../../..";
import { Box } from "../../../../../../components/box";
import { Icon } from "../../../../../../components/icon";
import { EditForm } from "./edit-form";
import { PATH } from "../../constant/path";

export const Edit: FC = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="ITCodeGrantedCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div
              className="btnBack"
              onClick={() => {
                history.push(PATH.HOME);
              }}
            >
              <Icon.ArrowLeft />
            </div>
            SỬA PHIẾU ĐỀ NGHỊ VĂN PHÒNG PHẨM
          </div>
        </div>
        
        <Box title="Nội dung">
          <EditForm />
        </Box>
      </div>
    </div>
  );
});
